export default {
  contractScheduledRateChanges: []
}
